import { FormControlLabel, Grid, Switch } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { ClientJobFunctionDto, StepDto } from '../../../../../../dtos';
import { ViewJobFunctionMembersButton } from '../../../../../JobFunction/Components';
import { EditStepAssignmentInput } from './EditStepAssignmentInput';
import { SmartValueListItem } from './SmartValueSlice';

export interface IAssignmentInput {
    fieldErrors: Map<keyof StepDto, string>;
    isExternal: boolean;
    handleIsExternalChange: (event: ChangeEvent<HTMLInputElement>, isChecked: boolean) => void;
    externalRoleName: string;
    handleExternalRoleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    formInternalJobFunctionId: string;
    handleInternalJobFunctionChange: (updatedJobFunction: ClientJobFunctionDto | undefined) => void;
    InternalJobFunction?: ClientJobFunctionDto;
    tag: string;
    handleTagChange: (tag: string) => void;
    smartValues: SmartValueListItem[];
}

export const StepAssignmentInput: FC<IAssignmentInput> = ({
    fieldErrors,
    isExternal,
    handleIsExternalChange,
    externalRoleName,
    handleExternalRoleChange,
    formInternalJobFunctionId,
    handleInternalJobFunctionChange,
    tag,
    handleTagChange,
    InternalJobFunction,
    smartValues
}) => {
    return (
        <>
            <Grid item xs={6} sm={4} md={3} ml={-2} mt={-1} display='flex' justifyContent='flex-start'>
                <FormControlLabel control={<Switch checked={isExternal} onChange={handleIsExternalChange} />} label='External' labelPlacement='start' />
            </Grid>
            <Grid item>
                <EditStepAssignmentInput
                    isExternalStep={isExternal}
                    fieldErrors={fieldErrors}
                    externalRoleName={externalRoleName}
                    handleExternalRoleNameChange={handleExternalRoleChange}
                    internalJobFunctionId={formInternalJobFunctionId}
                    handleInternalJobFunctionChange={handleInternalJobFunctionChange}
                    tag={tag}
                    handleTagChange={handleTagChange}
                    smartValues={smartValues}
                />
            </Grid>
            {!isExternal && (
                <Grid item mt={2}>
                    <ViewJobFunctionMembersButton jobFunction={InternalJobFunction} />
                </Grid>
            )}
        </>
    );
};
